import { frontendURL } from 'dashboard/helper/URLHelper';
import TicketsIndex from './pages/TicketsIndex.vue';
import { ROLES, CONVERSATION_PERMISSIONS } from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tickets'),
    name: 'tickets_index',
    component: TicketsIndex,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
